import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { Layout } from '@core/components/layout/layout';
import { UpgradeDialog } from '@core/components/upgrade-dialog/upgrade-dialog';
import { Title } from '@angular/platform-browser';
import { environment } from '@environment';

@Component({
  selector: 'm4w-root',
  imports: [Layout, ToastModule, UpgradeDialog],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly title = inject(Title);

  constructor() {
    if (!environment.production) {
      const title = this.title.getTitle();

      this.title.setTitle(title + ' - Test Env');
    }
  }
}
